export const SITE_URL = "historyind.maximquiz.com";
